import { nodeInstance } from "@/plugins/axios";

const networkingBreakoutService = {};

networkingBreakoutService.openBreakouts = (data) => {
  // { networkingId, mode: 'manual'|'random'|'free', rooms, names?, aforo? }
  return nodeInstance.post(`/api/networking/breakout/open`, data);
};

networkingBreakoutService.getBreakouts = (networkingId, { silent } = {}) => {
  return nodeInstance.get(`/api/networking/breakouts`, {
    params: { networkingId },
    silent: Boolean(silent),
  });
};

networkingBreakoutService.assignBreakouts = (data) => {
  // { networkingId, assignments: [{ userId, breakoutId | null }] }
  return nodeInstance.patch(`/api/networking/breakout/assign`, data);
};

networkingBreakoutService.joinBreakout = (data) => {
  // { networkingId, breakoutId | null }
  return nodeInstance.post(`/api/networking/breakout/join`, data);
};

networkingBreakoutService.closeBreakouts = (data) => {
  // { networkingId }
  return nodeInstance.patch(`/api/networking/breakout/close`, data);
};

export default networkingBreakoutService;
